"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const utils_1 = require("../utils");
const types = require("./types");
const typesSession = require("../session/types");
// eslint-disable-next-line @rushstack/typedef-var
const errorMessage = utils_1.createErrorMessageReducer('me');
// eslint-disable-next-line @rushstack/typedef-var
const isProcessing = utils_1.createIsProcessingReducer('me');
// eslint-disable-next-line @rushstack/typedef-var
const user = utils_1.createReducer(null)({
    [types.UPDATE_SUCCESS]: (state, action) => action.me,
    [typesSession.LOGOUT_SUCCESS]: () => null,
    [typesSession.LOGIN_SUCCESS]: (state, action) => action.me
});
exports.default = redux_1.combineReducers({
    errorMessage,
    isProcessing,
    user
});
//# sourceMappingURL=reducers.js.map